import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import { InputField, LabelField } from "components";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { getCurrency } from "helper/numberFormat";
import { findLast } from "lodash";
import React, { useEffect, useMemo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import thousands from "thousands";
import { CheckFloatValue } from "../../../../utils/functions";
import { MyCheckbox } from "components";

export const Check = ({ formik, ...props }) => {
  const currency = getCurrency();

  const dateTimeMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormate || "mm/dd/yyyy");

   const isOptionalObject = useMemo(() => {

    if (

      !Array.isArray(formik["values"]["allPaymentsMethods"]) ||

      formik["values"]["allPaymentsMethods"].length === 0

    )

      return;



    const currentComponent = formik["values"]["allPaymentsMethods"].find(

      (item) => {

        return item.type === "check";

      }

    );

    if (!currentComponent ||!currentComponent._id) return;

    return { id:currentComponent?._id,
      coverConvenienceFee: currentComponent?.coverConvenienceFee ?? false, 
      isOptional:currentComponent?.convenienceFeeInfo?.optional ?? false,

          message:currentComponent?.convenienceFeeInfo?.message,

          type: currentComponent?.type,

      }

  }, [formik["values"]]);


    useEffect(() => {

    if (!isOptionalObject?.isOptional) return;

    if (!key) return;

  

    if (formik.values[key] === undefined) {

      formik.setFieldValue(key, true);

    }

  }, [key, isOptionalObject]);

  

    const key = `${isOptionalObject?.id}`;


  function convertUTCToLocalDate(date) {
    if (!date) {
      return date
    }
    date = new Date(date)
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
    return date
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }
  const addNewCheck = () => {
    const validate = formik.values.checks?.every((item) => {
      const { amount, check_date, check_number } = item;
      return !!(amount && check_date && check_number);
    });
    if (validate) {
      formik.setFieldValue("checks", [
        ...formik.values.checks,
        {
          amount: "",
          check_date: "",
          check_number: "",
          paymentMethod: props.title,
        },
      ]);
    } else {
      toastr.info("Validation", "Please fill all the required fields first");
    }
  };

  useEffect(() => {
    if (!formik.values?.checks?.length) {
      formik.setFieldValue("checks", [
        {
          amount: "",
          check_date: "",
          check_number: "",
          paymentMethod: props.title,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeCheck = (idx) => {
    const checksList = [...formik.values.checks];
    checksList.splice(idx, 1);
    formik.setFieldValue("checks", checksList);
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
  return (
    <>
      {formik.values?.checks?.map((item, idx) => (
        <div className="d-flex mt-5" style={{ marginBottom: -10 }}>
          <div className="col-sm-3" key={idx}>
            <InputField
              type="number"
              {...{
                formik,
                title: "Amount",
                name: `checks.${idx}.amount`,
                placeholderIcon: (
                  <span className="align-self-center px-4">{currency}</span>
                ),
                value: item?.amount,
              }}
              onKeyDown={(e) => preventArrows(e)}
              handleChange={(e) => {
                formik.setFieldValue(
                  `checks.${idx}.amount`,
                  e.target.value.match(regex)[0]
                );
              }}
            />
          </div>
          <div className="col-sm-3">
            <LabelField title={"Check Date"} mandatory />
              <DatePicker
                isClearable
                showIcon
                popperPlacement="top"
                popperProps={{ strategy: "fixed" }}
                placeholderText={placeholderFormat}
                dateFormat={dateFormate}
                selected={
                    convertUTCToLocalDate(item?.check_date)
                }
                onChange={(e) => {
                  formik.setFieldValue(`checks.${idx}.check_date`, e);
                  convertLocalToUTCDate(e, `checks.${idx}.check_date`);
                  document.getElementsByName(`checks.${idx}.check_number`)[0].focus();
                }}
                onKeyDown={(e) => {
                  if(e.key === "Tab") {
                    e.preventDefault();
                    document.getElementsByName(`checks.${idx}.check_number`)[0].focus()
                  }
                }}
                customInput={
                  <MaskedInput
                    pipe={autoCorrectedDatePipe}
                    mask={dateTimeMask}
                    keepCharPositions={true}
                    guide={true}
                  />
                }
              />
          </div>
          <div className="col-sm-4">
            <InputField
              type="string"
              {...{
                formik,
                title: "Check Number",
                name: `checks.${idx}.check_number`,
                value: item?.check_number,
              }}
              maxLength={21}
              onKeyDown={(e) => preventArrows(e)}
              handleChange={(e) => {
                formik.setFieldValue(
                  `checks.${idx}.check_number`,
                  e.target.value.match(regex)[0]
                );
              }}
            />
          </div>
          <button
            type="button"
            className="btn btn-link btn-sm"
            onClick={() => removeCheck(idx)}
          >
            Delete
          </button>

          {/* <CrossSvg onClick={() => removeCheck(idx)} /> */}

        </div>
      ))}
      <div className="add-new-payment-info col my-4" onClick={addNewCheck}>
        <span className="add-icon">
          <AddIcon />
        </span>
        <span className="add">Add Check</span>
      </div>

       {!!formik.values?.checks?.length &&
  isOptionalObject?.coverConvenienceFee &&
        isOptionalObject?.isOptional && ( // Todo:add optional true

          <div

            className="d-flex mt-4"

            style={{

              minWidth: "216px",

justifyContent: "flex-end",

    display: "flex",

    width: "89%",

            }}

          >

            <div className="d-flex align-items-center mb-2">

              <MyCheckbox

                name={key}

                    checked={formik.values?.[key]}

                    onClick={(e) => {

                      formik.setFieldValue(

                        key,

                        e.target.checked

                      );

                    }}

                

               

              />

              <LabelField  style={{ display: "flex", alignItems: "center",  marginBottom: 0,    }}  title="Convenience Fee" />

            </div>

          </div>

        )}
    </>
  );
};
export const CheckHeader = ({ formik, ...props }) => {
  const currency = getCurrency();

  const { expanded, current } = props;

  const total = useMemo(() => {
    const values = findLast(
      formik.values?.payments ?? [],
      (item) => item.paymentMethod === props.title
    );
    return values?.amount ?? formik.values?.check_payment?.amount;
  }, [formik.values.payments, props.title]);

  const checksArray = formik.values?.checks.filter(function (value) {
    return !value.amount == "";
  });

  const totalValue = checksArray?.reduce(
    (pre, curr) =>
      parseFloat(pre) +
    (curr.amount == "" ? parseFloat(curr.amount) : parseFloat(curr.amount)),
    parseInt(0)
  );
  const handlefieldClick = (e) => {
    if (e.stopPropagation && expanded === true) {
      e.stopPropagation();
    }
  };
  const focusFirstCheckAmount = (e) => {
    handlefieldClick(e);
    const el = document.getElementsByName("checks.0.amount")[0];
    if (el) el.focus();
  };
  const handleOnChange = (event) => {
    formik.setFieldValue("check", event.target.value);
    formik.setFieldValue("checks.0.amount", event.target.value);
  };
  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(parseFloat(num?.toString().replace(/,/g, "")))
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <div
      className={
        expanded === false && current?.includes("check") === true
          ? "accordion-header"
          : expanded === false
            ? "accordion-payment-header"
            : expanded === true
              ? "accordion-header"
              : "accordion-header-payment"
      }
      id="some"
    >
      <LabelField title="Check" />
      <div
        className={
          expanded === false && current?.includes("check")
            ? "custom-expand dollor-icon col-sm-3 nonexpanded-amount"
            : expanded === false &&
              current?.includes("check") === false &&
              totalValue
              ? "custom-expand dollor-icon col-sm-3 nonexpanded"
              : "col-sm-3"
        }
      >
        {expanded === false && current?.includes("check") && totalValue ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            {/* <span>{getCommaSeperatedValue(totalValue)}</span> */}
            <span>{isNaN(totalValue) ? "0.00" : thousands((+totalValue).toFixed(2))}</span>

          </div>
        ) : current?.includes("check") && expanded === true ? (
          <InputField
            {...{
              formik,
              title: "none",
              name: `val`,
              style: { background: "#ffff", border: "none" },
              placeholderIcon: (
                <span
                  className="align-self-center px-4"
                  style={{ color: "black" }}
                >
                  {currency}
                </span>
              ),
              value: totalValue > 0 ? CheckFloatValue(totalValue) : "",
            }}
            paymentInput="paymentInput"
            handleFocus={(e) => focusFirstCheckAmount(e)}
            handleChange={(event) => handleOnChange(event)}
          />
        ) : expanded === false &&
          current?.includes("check") === false &&
          totalValue ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            {/* <span>{getCommaSeperatedValue(totalValue)}</span> */}
            <span>{isNaN(totalValue) ? "0.00" : thousands((+totalValue).toFixed(2))}</span>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
